import { createFileRoute } from "@tanstack/react-router";
import AudioFlow from "@/features/assessments/pages/audio/AudioFlow";

export const Route = createFileRoute("/$locale/$partner/_evaluation/audio")({
	component: AudioFlow,
});
